(() => {
  // Zorgt dat de zwevende WebwinkelKeur-topbar/zijbalk tijdelijk uit beeld gaat
  // zodra er een modal/drawer open staat op de site (bijv. de winkelwagen-
  // sidebar of de productfoto-zoom), zodat het kruisje van die modal altijd
  // klikbaar is. Zodra de modal weer dicht is, komt de balk gewoon terug — hij
  // wordt dus niet permanent verwijderd. De topbar blijft dus gewoon overal
  // elders normaal zichtbaar, precies zoals gewenst.
  if (window.__saWwkOverlayFixBound) return;
  window.__saWwkOverlayFixBound = true;

  var ID_CLASS_SELECTOR = [
    '[id*="webwinkelkeur" i]',
    '[class*="webwinkelkeur" i]',
    '[id*="wwk" i]',
    '[class*="wwk" i]',
    'iframe[src*="webwinkelkeur"]',
  ].join(',');

  function isFloating(el) {
    var cs = getComputedStyle(el);
    if (cs.position === 'fixed' || cs.position === 'sticky') return true;
    // Sommige onderdelen van de WebwinkelKeur-widget (zoals de topbalk) staan
    // niet op position:fixed/sticky, maar gebruiken wél een extreem hoge
    // z-index (vlak bij de maximale 32-bit waarde, 2147483647) om altijd
    // bovenop te blijven liggen — ook boven een fullscreen modal met een
    // "normale" z-index zoals de productfoto-zoom. Zonder deze extra check
    // werd zo'n element nooit als "storend" herkend en dus nooit verborgen.
    var z = parseInt(cs.zIndex, 10);
    return !isNaN(z) && z > 100000;
  }

  // Vangnet: als de widget geen herkenbare class/id gebruikt, zoeken we ook op
  // de zichtbare tekst "WebwinkelKeur" binnen korte, zwevende topniveau-
  // elementen (directe kinderen van body/html). Kort houden voorkomt dat we
  // per ongeluk een grote wrapper pakken die toevallig het woord bevat.
  function collectFixedTopLevelCandidates() {
    var candidates = [];
    [document.body, document.documentElement].forEach(function (root) {
      if (!root) return;
      Array.prototype.forEach.call(root.children, function (el) {
        if (!isFloating(el)) return;
        var text = (el.textContent || '').trim();
        if (text.length > 0 && text.length < 400 && /webwinkelkeur/i.test(text)) {
          candidates.push(el);
        }
      });
    });
    return candidates;
  }

  function findFloatingWwkElements() {
    var found = [];

    document.querySelectorAll(ID_CLASS_SELECTOR).forEach(function (el) {
      if (isFloating(el)) {
        found.push(el);
        return;
      }
      var parent = el.parentElement;
      while (parent && parent !== document.body) {
        if (isFloating(parent)) {
          found.push(parent);
          return;
        }
        parent = parent.parentElement;
      }
    });

    collectFixedTopLevelCandidates().forEach(function (el) {
      if (found.indexOf(el) === -1) found.push(el);
    });

    return found;
  }

  function hideWwk() {
    findFloatingWwkElements().forEach(function (el) {
      if (el.dataset.saWwkHidden === 'true') return;
      el.dataset.saWwkHidden = 'true';
      el.style.setProperty('visibility', 'hidden', 'important');
      el.style.setProperty('pointer-events', 'none', 'important');
    });
  }

  function showWwk() {
    document.querySelectorAll('[data-sa-wwk-hidden="true"]').forEach(function (el) {
      el.style.removeProperty('visibility');
      el.style.removeProperty('pointer-events');
      delete el.dataset.saWwkHidden;
    });
  }

  // Meerdere signalen combineren voor "staat er een modal/drawer open",
  // zodat we niet afhankelijk zijn van precies één implementatie:
  // - Dawn's algemene 'overflow-hidden' op <body>
  // - een actieve <cart-drawer class="active">
  // - een zichtbaar element met aria-modal="true" (productfoto-zoom e.d.)
  // - een open <dialog>
  function isModalOpen() {
    if (document.body && document.body.classList.contains('overflow-hidden')) return true;

    var drawer = document.querySelector('cart-drawer.active');
    if (drawer) return true;

    var ariaModal = document.querySelector('[aria-modal="true"]:not([hidden])');
    if (ariaModal) {
      var style = getComputedStyle(ariaModal);
      if (style.display !== 'none' && style.visibility !== 'hidden') return true;
    }

    var dialog = document.querySelector('dialog[open]');
    if (dialog) return true;

    return false;
  }

  function sync() {
    if (isModalOpen()) {
      hideWwk();
    } else {
      showWwk();
    }
  }

  function start() {
    sync();

    // Body-class, drawer/modal-attributen én algemene DOM-wijzigingen kunnen
    // allemaal een reden zijn om opnieuw te checken.
    var observer = new MutationObserver(sync);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class', 'open', 'aria-modal', 'hidden'],
      childList: true,
      subtree: true,
    });

    // Extra vangnet: elke 400ms even checken. Heel licht (alleen class-checks),
    // maar vangt gevallen op die geen enkele MutationObserver-trigger geven.
    window.setInterval(sync, 400);
  }

  if (document.body) {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  }
})();